<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
    color="red"
  ></v-btn>

  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-text-field
            v-model="formData.name"
            :rules="nameRules"
            label="الاسم"
          ></v-text-field>
          <v-text-field
            v-model="formData.phone"
            :rules="phoneRules"
            label="الجوال"
          ></v-text-field>
          <v-text-field
            v-model="formData.address"
            :rules="addressRules"
            label="العنوان"
          ></v-text-field>
          <v-text-field
            type="number"
            v-model="formData.balance"
            :rules="balanceRules"
            label="الرصيد"
          ></v-text-field>
          <v-select
            v-model="formData.meter_parent_id"
            :items="parents"
            label="العداد الأب"
            item-title="name"
            item-text="code"
            item-value="id"
          >
          </v-select>
          <v-select
            v-model="formData.meter_status"
            label="الحالة"
            :items="statuses"
            item-title="name"
            item-text="name"
            item-value="val"
          >
          </v-select>
          <v-text-field
            v-model="formData.meter_code"
            :rules="codeRules"
            label="الرقم"
          ></v-text-field>
          <v-text-field
            v-model="formData.meter_name"
            :rules="nameRules"
            label="الاسم"
          ></v-text-field>
          <v-checkbox
            label="عداد زبون"
            disabled
            color="info"
            :model-value="true"
          ></v-checkbox>
          <v-text-field
            type="number"
            v-model="formData.initial_reading"
            label="القراءة الأولية"
          ></v-text-field>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
export default {
  components: {
    // DialogMeter,
  },
  props: ["saveFunction", "item", "mode", "iconName", "parents"],
  data() {
    return {
      isActive: false,
      //statuses: ["working", "free", "deleted", "bad", "fixing"],
      statuses: [
        { name: this.$t("working"), val: "working" },
        { name: this.$t("free"), val: "free" },
        { name: this.$t("deleted"), val: "deleted" },
        { name: this.$t("bad"), val: "bad" },
        { name: this.$t("fixing"), val: "fixing" },
      ],
      formData: {
        name: "",
        phone: "",
        address: "",
        balance: 0,
        meter_code: "",
        meter_name: "",
        meter_status: "",
        meter_parent_id: "",
        meter_isFinal: true,
        initial_reading: 0,
      },
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 50) || "Name must be less than 10 characters",
      ],
      phoneRules: [(v) => !!v || "Phone is required"],
      addressRules: [(v) => !!v || "Address is required"],
      balanceRules: [(v) => !!v || "balance is required"],
      //balanceRules: [(v) => (!!v && v >= 0) || "Balance should be positive"],
    };
  },
  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.saveData();

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
    async saveData() {
      const res = await repo.customers.addWithMeter(this.formData);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
    },
  },
  //   watch: {
  //     isActive(value) {
  //       if (value) {
  //         if (this.mode == "edit") {
  //           this.formData = { ...this.item };
  //         }
  //       }
  //     },
  //   },
  computed: {
    title() {
      return "إضافة زبون مع عداد";
      //   if (this.mode == "add") return "إضافة زبون";
      //   return "تعديل زبون";
    },
  },
};
</script>
